module.exports = __webpack_public_path__ + "df09fb14ab058f90d80aa02f253118f6.svg";